import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import Popover from './Panel';
import Button from '../Button';
import Alert from '../Alert';
import { Component } from '../component';
import { popoverClass } from './styles';
import { getLocale } from '../locale';
var DefaultProps = {
  type: 'confirmwarning',
  icon: true,
  okType: 'danger'
};

var Confirm =
/*#__PURE__*/
function (_Component) {
  _inherits(Confirm, _Component);

  var _super = _createSuper2(Confirm);

  function Confirm(props) {
    var _this;

    _classCallCheck(this, Confirm);

    _this = _super.call(this, props);
    _this.handleCancel = void 0;
    _this.handleOk = void 0;
    _this.state = {
      ok: false,
      cancel: false
    };
    _this.handleCancel = _this.handleClick.bind(_assertThisInitialized(_this), 'cancel');
    _this.handleOk = _this.handleClick.bind(_assertThisInitialized(_this), 'ok');
    return _this;
  }

  _createClass(Confirm, [{
    key: "handleClick",
    value: function handleClick(type, close) {
      var _this2 = this;

      var _this$props = this.props,
          onOk = _this$props.onOk,
          onCancel = _this$props.onCancel;
      var fn = type === 'ok' ? onOk : onCancel;
      var callback;
      if (fn) callback = fn();

      if (callback && typeof callback.then === 'function') {
        this.setState(_defineProperty({}, type, true), function () {
          ;
          callback.then(function () {
            close();

            _this2.setState(_defineProperty({}, type, false));
          });
        });
      } else {
        close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          _this$props2$type = _this$props2.type,
          type = _this$props2$type === void 0 ? DefaultProps.type : _this$props2$type,
          text = _this$props2.text,
          onOk = _this$props2.onOk,
          okType = _this$props2.okType,
          onCancel = _this$props2.onCancel,
          icon = _this$props2.icon,
          other = _objectWithoutProperties(_this$props2, ["children", "type", "text", "onOk", "okType", "onCancel", "icon"]);

      var _this$state = this.state,
          ok = _this$state.ok,
          cancel = _this$state.cancel;
      return (
        /*#__PURE__*/
        React.createElement(Popover, Object.assign({}, other, {
          trigger: "click"
        }), function (close) {
          return (
            /*#__PURE__*/
            React.createElement("div", {
              className: popoverClass('confirm')
            },
            /*#__PURE__*/
            React.createElement("div", {
              className: popoverClass('mention')
            },
            /*#__PURE__*/
            React.createElement(Alert, {
              type: type,
              icon: icon,
              className: popoverClass('alert')
            }, children)),
            /*#__PURE__*/
            React.createElement("div", {
              className: popoverClass('footer')
            },
            /*#__PURE__*/
            React.createElement(Button, {
              loading: cancel,
              size: "small",
              onClick: function onClick() {
                return _this3.handleCancel(close);
              }
            }, getLocale('cancel', text)),
            /*#__PURE__*/
            React.createElement(Button, {
              loading: ok,
              size: "small",
              type: okType,
              onClick: function onClick() {
                return _this3.handleOk(close);
              }
            }, getLocale('ok', text))))
          );
        })
      );
    }
  }]);

  return Confirm;
}(Component);

Confirm.defaultProps = DefaultProps;
export { Confirm as default };